/**
 * Pryme protocol v1 — shared wire vocabulary.
 * Normative description: docs/PROTOCOL.md. Machine-readable API: openapi.json.
 */
export const PROTOCOL_VERSION = 1;
export const REQUEST_SIG_VERSION = 'pryme-request-v1';
/** JWS `typ` values. Every verifier MUST check typ (domain separation). */
export const TYP = {
    /**
     * Pryme's attestation issuer certifies that a pairwise key represents a verified, active Pryme
     * identity for one audience (a service). Not signed with any service credential (ADR-0014).
     */
    binding: 'pryme-binding-v2',
    /** Pairwise key signs derived claim state for one recipient. */
    state: 'pryme-state-v1',
    /** Pairwise key signs a delegation to an agent principal. */
    mandate: 'pryme-mandate-v1',
    /** Pairwise key signs an authorization decision for one exact operation. */
    decision: 'pryme-decision-v1',
    /** Service A key signs a gateway response to a signed service request (the service channel only). */
    response: 'pryme-response-v1',
    /** Pairwise key signs the human's approval of one exact escalated operation. */
    approval: 'pryme-approval-v1',
    /**
     * The agent's own key signs the exact operation it asks one recipient to perform (ADR-0015).
     * Without it, a check is the service's own request: it may ask the human, never use the agent's permission.
     * Pryme's own EdDSA JWS type: not an AP2 mandate, and never accepted where one is expected (or vice versa).
     */
    intent: 'pryme-intent-v1',
};
export const HEADERS = {
    service: 'pryme-service',
    agent: 'pryme-agent',
    keyId: 'pryme-key-id',
    audience: 'pryme-audience',
    timestamp: 'pryme-timestamp',
    nonce: 'pryme-nonce',
    digest: 'pryme-content-digest',
    signature: 'pryme-signature',
    binding: 'pryme-binding',
    mandate: 'pryme-mandate',
    approval: 'pryme-approval',
    /** The agent's signed intent (`pryme-intent-v1`) for the operation this request asks for. */
    intent: 'pryme-intent',
    responseSignature: 'pryme-response-signature',
    stepUp: 'pryme-step-up',
};
/** Maximum clock skew / signed-request lifetime in seconds. */
export const REQUEST_MAX_AGE_SECONDS = 300;
export const ERROR_CODES = [
    'identity_not_verified',
    'verification_pending',
    'verification_denied',
    'verification_expired',
    'verification_provider_unavailable',
    'unsupported_verification_scheme',
    'assurance_insufficient',
    'duplicate_identity_review_required',
    'invalid_signature',
    'unregistered_service',
    'unverified_domain',
    'wrong_audience',
    'replay_detected',
    'expired_presentation',
    'unknown_pairwise_identity',
    'consent_required',
    'claim_not_disclosed',
    'issuer_not_verified',
    'mandate_revoked',
    'mandate_expired',
    'constraint_violation',
    'approval_required',
    'approval_denied',
    'credential_revoked',
    'identity_recovery_required',
    'rate_limited',
    'temporarily_unavailable',
    // PoC extensions
    'invalid_request',
    'invalid_state',
    'mandate_suspended',
    'agent_not_authorized',
    'handle_unavailable',
    'step_up_required',
    'forbidden',
    'not_found',
];
export const SUPPORTED_CLAIMS = [
    'human.verified',
    'age.over13',
    'age.over15',
    'age.over16',
    'age.over18',
    'age.over21',
    'residency.country',
];
export * from './interop.js';
